module.exports = __webpack_public_path__ + "static/JohnnyHeadshot-b6eba6b5e4f474710bf35a0f0cbfc5c3.jpeg";